import { useTranslations } from 'next-intl';

import { Button } from '@flipster/react/design-system/button';
import { css } from '@flipster/styled-system/css';
import webviewHandler from '@flipster/utils/webview-handler';

const Footer = () => {
  const t = useTranslations();
  return (
    <footer
      className={css({
        position: 'fixed',
        bgColor: 'background.default.level-0',
        bottom: 0,
        left: 0,
        right: 0,
        px: 16,
        pt: 16,
        pb: 24,
      })}
    >
      <Button
        label={t('Autogen_common.r251126.s_Ok')}
        css={{ width: '100%' }}
        onClick={() => webviewHandler.postMessage({ action: 'close' })}
      />
    </footer>
  );
};

export default Footer;
